import { tns } from 'tiny-slider';

document.addEventListener(
	'DOMContentLoaded',
	function () {
		const stepsSlider = tns({
			container: '.steps .steps__slider',
			nav: true,
			navPosition: "bottom",
			controlsPosition: "bottom",
			mouseDrag: true,
			controls: true,
			loop: false,
			edgePadding: 0,
			items: 1,
			autoplay: false,
			arrowKeys: true,
			gutter: 30,
			controlsText: ['<?xml version="1.0" ?><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z"/></g></svg>', '<?xml version="1.0" ?><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><title/><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z"/></g></svg>'],
			responsive: {
				500: {
					items: 2,
				},
				768: {
					items: 3,
				},
				1024: {
					nav: false,
					items: 4,
				},
			},
		});
	},
	false
);
